import React from 'react';
import { Col, Row, } from 'react-bootstrap';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import SvgIcon from '@material-ui/core/SvgIcon';
import ExpandMoreIcon from '../../../../icons/expand-more.svg';
import './BusinessHours.scss'

export default function BusinessHours(props) {

    const businessHours = {
        headers: ['Time Zone', 'Open From'],
        content: [
            ['Pacific Time Zone (PT)', '5am to 4:30pm'],
            ['Mountain Time Zone (MT)', '6am to 5:30pm'],
            ['Central Time Zone (CT)', '7am to 6:30pm'],
            ['Eastern Time Zone (ET)', '8am to 7:30pm']
        ]
    }

    return (
        <ExpansionPanel className={`business-hours mb-3 ${props.hideBackground ? 'business' : ''}`}>
            <ExpansionPanelSummary
                expandIcon={<SvgIcon id="expand-more-icon" component={ExpandMoreIcon} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="p-0 m-0 justify-content-start"
            >
                <p id="business-hours-header" className="m-0">Business Hours Monday-Friday</p>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="flex-column p-0 pb-4">
                <Row>
                    {businessHours.headers.map((h, index) =>
                        <Col key={index} xs={6}><p id={`${h} label`} className="summary-details-label">{h}</p></Col>
                    )}
                </Row>

                {businessHours.content.map((item, index) =>
                    <Row key={index}>
                        {item.map((text, j) =>
                            <Col key={j} xs={6} className="mt-auto"><p id={`busHour-${text}`} className="summary-details-business-time">{text}</p></Col>
                        )}
                    </Row>
                )}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    )
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/BusinessHours.js